import MuiTab from '@mui/material/Tab';
import MuiTabs from '@mui/material/Tabs';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useActivePath } from 'shared/hooks/use-active-path';
import { QueryNavLink } from 'shared/lib/react-router-dom';
import { Paths } from 'shared/routes';
import { replaceUrlParams } from 'shared/utils/replace-url-params';

const tabs = [
  {
    label: 'pages.goal-detail.tabs.summary.label',
    path: Paths.GoalDetail,
  },
  {
    label: 'pages.goal-detail.tabs.progress.label',
    path: Paths.GoalDetailProgress,
  },
  {
    label: 'pages.goal-detail.tabs.tasks.label',
    path: Paths.GoalDetailTasks,
  },
];

export const NavigationTabs: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const activePath = useActivePath();

  const activeIndex = useMemo(
    () => tabs.findIndex(({ path }) => path === activePath),
    [activePath],
  );

  return (
    <MuiTabs value={activeIndex} variant="scrollable" scrollButtons={false}>
      {tabs.map(({ label, path }) => (
        <MuiTab
          key={path}
          label={t(label)}
          component={QueryNavLink}
          to={replaceUrlParams(path, { id: id! })}
          iconPosition="end"
          sx={{
            WebkitAppRegion: 'no-drag',
          }}
          replace
          disableRipple
        />
      ))}
    </MuiTabs>
  );
};
